const time = window.cuttentTime || Date.parse(new Date().toString());

export default time;



// WEBPACK FOOTER //
// ./src/static-data/time.js